import { Component, OnInit } from '@angular/core';
import { formatDate, DatePipe } from '@angular/common';
import { MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, FormArray, FormGroup, Validators, ValidatorFn, ValidationErrors, AbstractControl, AbstractControlOptions } from '@angular/forms';

import { AppService } from '../../_services/app.service';
import { ServerConn } from 'src/app/_services/serverConn.service';
import { ProductsService } from './../../_services/products.service';
import { TWADialogsService } from 'src/app/_services/twa-dialogs.service';

@Component({
    selector: 'app-product-receive-dialog-component',
    templateUrl: './product-receive-dialog.component.html',
    styleUrls: ['./product-receive-dialog.component.css'],
    standalone: false
})
export class ProductReceiveDialogComponent implements OnInit {

  title = 'Nueva recepción de material';

  // pipe = new DatePipe('en-US');
  form = this.fb.group({
    idalmacen: ['', Validators.required],
    idproducto: ['', Validators.required],
    // fecha: [this.pipe.transform(Date.now(), 'yyyy-MM-dd'), Validators.required],
    fecha: [formatDate(new Date().toISOString(), 'yyyy-MM-dd', 'en-US')],
    idcomunidad: ['', Validators.required],
    numeracion: [''],
    cantidad: [1, [Validators.required, Validators.min(1)]]
  });

  comunidades: any[] = [];
  products: any[] = [];
  stores: any = [];

  constructor(
    private dialogRef: MatDialogRef<ProductReceiveDialogComponent>,
    private fb: UntypedFormBuilder,
    private appSvc: AppService,
    private productsSvc: ProductsService,
    private server: ServerConn,
    private dlgsSvc: TWADialogsService,
  ) { }

  ngOnInit() {
    console.log('🚀 ~ file: product-receive-dialog.component.ts:50 ~ ProductReceiveDialogComponent ~ ngOnInit ~ this.form:', this.form);
    this.appSvc.comunidades$.subscribe((data: any) => {
      console.log('🚀 ~ file: product-receive-dialog.component.ts:37 ~ ProductReceiveDialogComponent ~ this.appSvc.comunidades$.subscribe ~ data:', data);
      this.comunidades = data;
    });
    this.productsSvc.get().subscribe((res: any) => {
      if (res.result) {
        this.products = res.data;
      }
    });
    this.server.get('stores').subscribe((res: any) => {
      this.stores = res.data;
      console.log('🚀 ~ file: product-receive-dialog.component.ts:54 ~ ProductReceiveDialogComponent ~ this.server.get ~ this.stores:', this.stores);
    });
  }

  displayProduct(product: any) {
    console.log('🚀 ~ file: product-receive-dialog.component.ts:47 ~ ProductReceiveDialogComponent ~ displayProduct ~ product:', product);
    return product?.nombre;
  }

  productChanged() {

  }

  save(force = false) {
    const data = this.form.value;
    if (data.idproducto.id) {
      data.idproducto = data.idproducto.id;
    }
    data.fecha = formatDate(data.fecha, 'yyyy-MM-dd', 'en-US');
    if (force) {
      data.force = '1';
    }
    this.server.post(
      'stores/save-receipt',
      {
        d: JSON.stringify(data)
      }
    ).subscribe((res: any) => {
      console.log('🚀 ~ file: product-receive-dialog.component.ts:71 ~ ProductReceiveDialogComponent ~ ).subscribe ~ res:', res);
      if (res.result) {
        this.close(true);
      } else {
        if (res.data.exists) {
          this.dlgsSvc.confirm(
            'Numeración ya introducida',
            'Esa numeración ya aparece como recibida en AZASA ¿deseas continuar?',
            'Sí, generarla igualmente',
            'No, me lo voy a pensar'
          ).subscribe((res: any) => {
            if (res) {
              this.save(true);
            }
          });
        } else if (res.data.duplicated) {
          this.dlgsSvc.confirm(
            'Recepción duplicada',
            'Ya existe una recepción de material con esa numeración y esa fecha.',
            'Cerrar'
          ).subscribe((res: any) => {
          });
        }
      }
    });
  }

  close(result = false) {
    this.dialogRef.close(result);
  }

}
